import { useDemo } from "../zustand/DemoZustand";
import { Marke } from "./Grundelemente";
import { Dokument, Schloss, Waage } from "./Symbole";
import Ampelpunkte from "./Ampelpunkte";
import { standDesTop } from "../hilfen/auswertung";
import { langesDatum, tageBis, uhrzeit, wochentag } from "../hilfen/datum";

/*
  Teile, die sowohl auf der Startseite als auch in der Seitenleiste des iPads
  gebraucht werden: der Sitzungsanker und die Tagesordnung.
*/

export function SitzungsAnker({ schmal = false }) {
  const { stammdaten } = useDemo();
  const ausschuss = stammdaten.sitzungen[stammdaten.ausschussId];
  const fraktionssitzung = stammdaten.sitzungen["s-fraktion"];
  const tage = tageBis(ausschuss.beginn);

  return (
    <div className={`anker ${schmal ? "anker--schmal" : ""}`}>
      <p className="anker__vorspann">Nächste Sitzung · in {tage} Tagen</p>
      <h1 className="anker__titel">{stammdaten.gremien[ausschuss.gremiumId].name}</h1>
      {!schmal && <p className="anker__frage">Was muss ich bis dahin tun?</p>}

      <div className="zyklus">
        <div className="zyklus__schritt zyklus__schritt--jetzt">
          <span className="zyklus__tag">{wochentag(fraktionssitzung.beginn)}</span>
          <span>
            <strong>Fraktionssitzung</strong>, {uhrzeit(fraktionssitzung.beginn)}
            <br />
            <span className="zyklus__wo">{fraktionssitzung.ort}</span>
          </span>
        </div>
        <div className="zyklus__schritt">
          <span className="zyklus__tag">{wochentag(ausschuss.beginn)}</span>
          <span>
            <strong>Ausschusssitzung</strong>, {uhrzeit(ausschuss.beginn)}
            <br />
            <span className="zyklus__wo">{ausschuss.ort}</span>
          </span>
        </div>
      </div>
    </div>
  );
}

export function Tagesordnungsliste({ oeffne, gewaehltId = null }) {
  const { stammdaten } = useDemo();

  return (
    <ul className="tagesordnung">
      {stammdaten.tagesordnung.map((top) => (
        <TopZeile key={top.id} top={top} oeffne={oeffne} gewaehlt={top.id === gewaehltId} />
      ))}
    </ul>
  );
}

export function TagesordnungsHinweis() {
  const { stammdaten } = useDemo();
  const ausschuss = stammdaten.sitzungen[stammdaten.ausschussId];
  return `${stammdaten.gremien[ausschuss.gremiumId].name}, ${langesDatum(ausschuss.beginn)}. Aus dem Ratsinformationssystem der Verwaltung.`;
}

/*
  Eine Zeile der Tagesordnung.

  Regel dahinter: Die Information ist vollständig, aber so einfach wie
  möglich. Deshalb steht hier nur, was noch **offen** ist — „Ungelesen“,
  „Meinungsbild fehlt“. Fehlt die Marke, ist die Sache erledigt.

  Vorher stand an jeder Zeile „Gelesen · 44 Seiten“ und „Du: Dafür“. Das
  war doppelt gemoppelt: Der Kopf des Punktes sagt beides ohnehin, und eine
  Liste, in der neun Zeilen „erledigt“ rufen, hilft niemandem beim Finden
  dessen, was noch zu tun ist.

  Die drei Ampelpunkte bleiben — sie zeigen die Fraktion, nicht mich.
*/
function TopZeile({ top, oeffne, gewaehlt }) {
  const { stammdaten, zustand, ich } = useDemo();
  const stand = standDesTop(top, zustand, stammdaten, ich.id);

  if (top.formal) {
    return (
      <li>
        <div className="top top--formal">
          <span className="top__nummer">{top.nummer}</span>
          <span className="top__haupt">{top.titel}</span>
        </div>
      </li>
    );
  }

  const ungelesen = stand.datei && !stand.gelesen;
  const ohneMeinung = !stand.meineMeinung;

  return (
    <li>
      <button
        className={`top ${gewaehlt ? "top--gewaehlt" : ""}`}
        aria-current={gewaehlt ? "true" : undefined}
        onClick={() => oeffne("sitzung", { topId: top.id, reiter: "vorlage" })}
      >
        <span className="top__nummer">{top.nummer}</span>

        <span className="top__haupt">
          <span className="top__titel">{top.titel}</span>

          {(!top.oeffentlich || ungelesen || ohneMeinung) && (
            <span className="top__marken">
              {!top.oeffentlich && (
                <span className="marke-nichtoeffentlich">
                  <Schloss groesse={15} />
                  Nichtöffentlich
                </span>
              )}

              {ungelesen && (
                <Marke symbol={Dokument} art="offen">
                  Ungelesen · {stand.datei.seitenzahl} Seiten
                </Marke>
              )}

              {ohneMeinung && (
                <Marke symbol={Waage} art="offen">
                  Meinungsbild fehlt
                </Marke>
              )}
            </span>
          )}
        </span>

        <Ampelpunkte top={top} />
      </button>
    </li>
  );
}
